import { render, staticRenderFns } from "./BannerScroll.vue?vue&type=template&id=323ede95&scoped=true&"
import script from "./BannerScroll.vue?vue&type=script&lang=js&"
export * from "./BannerScroll.vue?vue&type=script&lang=js&"
import style0 from "./BannerScroll.vue?vue&type=style&index=0&id=323ede95&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323ede95",
  null
  
)

export default component.exports